

























































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import ProfitLoss from '@/charts/ProfitLoss.vue';
import FinancialRatioItem from '@/views/FinancialRatioItem.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';

@Component({components: {ProfitLoss, DynamicColumnChart, DynamicLineChart, FinancialRatioItem}})
export default class CardProfitLossNew extends CompanyMixin {
  selected: number = 5;
}
